import classnames from 'classnames';
import React from 'react';
import {getChildrenText, WebUI, getNid} from "../../wui-core/src";
import {BadgeProps} from "./iBadge"
import Ribbon from './Ribbon';
import {setComponentSize} from "../../wui-core/src/componentStyle"
import { WithConfigConsumer } from '../../wui-provider/src/context';

const defaultProps = {
    colors: 'primary',
    dataBadgePlacement: 'top',
    dot: false,
    showZero: false,
    dataBadge: null,
    count: null,
    overflowCount: 99,
    size: 'default',
    title: null,
    status: null,
    text: null,
    color: null,
    fieldid: undefined
};
const colorsMap = {
    primary: 'primary',
    default: 'primary',
    secondary: 'secondary',
    accent: 'accent',
    success: 'success',
    info: 'info',
    processing: 'info',
    warning: 'warning',
    danger: 'danger',
    error: 'danger',
    dark: 'dark',
    light: 'light'
}

const Badge: React.FC<BadgeProps> = (props) => {
    let {
        colors,
        className,
        children,
        clsPrefix,
        dataBadge,
        dataBadgePlacement,
        showZero,
        count,
        overflowCount,
        dot,
        color,
        title,
        status,
        offset,
        text,
        size,
        fieldid,
        dir,
        ...others
    } = props;

    let numberedDisplayCount;
    count = (count as number) - 0 == count ? (count as number) - 0 : count;
    let countHack = count ?? dataBadge;
    if (typeof countHack === 'number' && typeof overflowCount === 'number') {
        numberedDisplayCount = countHack > overflowCount ? `${overflowCount}+` : countHack;
    }
    const isZero = numberedDisplayCount === '0' || numberedDisplayCount === 0;
    const hasStatus = (status !== null && status !== undefined) || (color !== null && color !== undefined);
    const showAsDot = (dot && !isZero) || hasStatus || (!countHack && countHack !== 0 && countHack !== null);
    const mergedCount = showAsDot ? '' : numberedDisplayCount;
    const isEmpty = mergedCount === null || mergedCount === undefined || mergedCount === '';
    const titleNode = (title || title === '') ? getChildrenText(title).join('') : (typeof countHack === 'string' || typeof countHack === 'number' ? countHack : undefined);
    const isConsumer = React.isValidElement(countHack);
    const isHidden = (isEmpty || (isZero && !showZero)) && !showAsDot && !isConsumer;
    const displayNode = isConsumer ? countHack : numberedDisplayCount;
    const textNode = showAsDot && text && !isHidden ? (
        <span className={`${clsPrefix}-status-text`}>{text}</span>) : undefined;
    let colorHack = status || colors;

    let classNames = classnames(clsPrefix, {
        [`${className}`]: className,
	    [`${clsPrefix}-${colorsMap[colorHack!]}`]: colorsMap[colorHack!] && colorsMap[colorHack!] !== 'primary',
        [`${clsPrefix}-primary`]: !colorsMap[colorHack!] || colorsMap[colorHack!] === 'primary',
        [`data-badge`]: countHack || isZero || showAsDot,
        [`data-badge-${dataBadgePlacement}`]: dataBadgePlacement,
        [`${clsPrefix}-custom-component`]: isConsumer,
        [`${clsPrefix}-status`]: hasStatus,
        [`${clsPrefix}-not-a-wrapper`]: !children
    })

    let childClassNames = classnames('data-icon', {
        [`${clsPrefix}-dot`]: showAsDot && !textNode,
        [`${clsPrefix}-status-dot`]: showAsDot && !!textNode,
        [`${clsPrefix}-${setComponentSize(size!)}`]: !!setComponentSize(size!) && !showAsDot
    });

    let childIdObj:Pick<BadgeProps, 'fieldid'> = {};
    childIdObj.fieldid = fieldid ? `${fieldid}_data_icon` : undefined;

    let childStyle = {
        background: color,
        [(dir === 'rtl' ? "left" : "right")]: offset && -offset[0],
        marginTop: offset && offset[1],
    };
    let adapterNid = getNid(props);

    return (
        <span className={classNames} {...others} {...adapterNid}>
            <span>{children}{!isHidden && (<span title={showAsDot ? '' : (titleNode as string)} style={childStyle} {...childIdObj}
                className={childClassNames}>{showAsDot ? '' : displayNode as number}</span>)}{textNode}</span>
        </span>
    );
};

(Badge as any).Ribbon = Ribbon;
export default WithConfigConsumer({name: "badge"})(WebUI({name: "badge", defaultProps})(Badge));
